import React, {Component} from 'react';
import ReactDOM from 'react-dom';
class Blog extends React.Component {
    render() {
         return <div>
<div class="blog-section section pt-65 pt-lg-45 pt-md-35 pt-sm-20 pt-xs-15 pb-65 pb-lg-45 pb-md-35 pb-sm-25 pb-xs-15">
    <div class="container">

        <div class="row mb-50 mb-xs-20">
            <div class="col">
                <div class="section-title text-center">
                    <h2>Latest Post From Blog</h2>
                    <span>OUR BLOG POST</span>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="blog col-lg-4 col-md-6">
                <div class="blog-inner mb-30">
                    <div class="blog-media"><a href="blog-details" class="image"><img src="assets/images/blog/blog-1.jpg" alt=""/></a></div>
                    <div class="content">
                        <ul class="meta">
                            <li>08 April, 2019</li>
                            <li><a href="#">25 Likes</a></li>
                            <li><a href="#">28 Views</a></li>
                        </ul>
                        <h3 class="title"><a href="blog-details">Latest Fashion Trend for Women
                                new trens, new fashion</a></h3>
                        <a class="read-more" href="blog-details">Read more</a>
                    </div>
                </div>
            </div>

            <div class="blog col-lg-4 col-md-6">
                <div class="blog-inner mb-30">
                    <div class="blog-media"><a href="blog-details" class="image"><img src="assets/images/blog/blog-2.jpg" alt=""/></a></div>
                    <div class="content">
                        <ul class="meta">
                            <li>06 April, 2019</li>
                            <li><a href="#">42 Likes</a></li>
                            <li><a href="#">18 Views</a></li>
                        </ul>
                        <h3 class="title"><a href="blog-details">Latest Fashion Trend for Women
                                new trens, new fashion</a></h3>
                        <a class="read-more" href="blog-details">Read more</a>
                    </div>
                </div>
            </div>

            <div class="blog col-lg-4 col-md-6">
                <div class="blog-inner mb-30">
                    <div class="blog-media"><a href="blog-details" class="image"><img src="assets/images/blog/blog-3.jpg" alt=""/></a></div>
                    <div class="content">
                        <ul class="meta">
                            <li>02 April, 2019</li>
                            <li><a href="#">20 Likes</a></li>
                            <li><a href="#">78 Views</a></li>
                        </ul>
                        <h3 class="title"><a href="blog-details">Latest Fashion Trend for Women
                                new trens, new fashion</a></h3>
                        <a class="read-more" href="blog-details">Read more</a>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
         </div>
          }
        }
        export default Blog;